import React, {Component} from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {Button} from 'semantic-ui-react'

class PreviewResizer extends Component {
  static modes = ['tv', 'desktop', 'laptop', 'tablet', 'mobile']

  static propTypes = {
    setMode: PropTypes.func.isRequired,
    mode: PropTypes.string.isRequired,
  }

  render () {
    const {setMode, mode} = this.props
    const icons = {
      tv: 'tv',
      desktop: 'desktop',
      laptop: 'laptop',
      tablet: 'tablet alternate',
      mobile: 'mobile alternate',
    }

    return (
      <StyledPreviewResizer>
        {PreviewResizer.modes.map((m) =>
          <Button key={m} icon={icons[m]} className={m === mode ? 'active' : ''} onClick={() => setMode(m)} />
        )}
      </StyledPreviewResizer>
    )
  }
}

export const StyledPreviewResizer = styled(Button.Group)`
  max-width: 150px;
  .ui.button.active, .ui.button.active:hover, .ui.button.active:focus {
    background-color: ${props => props.theme.accentColor};
    color: white;
  }
`

export default PreviewResizer



// WEBPACK FOOTER //
// ./src/components/PreviewResizer.jsx